// extracted by mini-css-extract-plugin
export default {"root":"HVSnackBar_module-XVM2YES5_root__J5eFi","closeButton":"HVSnackBar_module-XVM2YES5_closeButton__4hslx","icon":"HVSnackBar_module-XVM2YES5_icon__XbR7S"};